// extracted by mini-css-extract-plugin
module.exports = {"mulitpleDropdown":"subjectsDropdown_mulitpleDropdown__1td2_"};